<template>
  <div>
    <audio ref="audio1" :src="audioSrc" v-show="false" :muted="true" :loop="true"></audio>
    <Modal v-model="modal.show" title="报警弹窗" width="80" :footer-hide="true" @on-cancel="cancelAlarm">
      <div class="receive-alarm-modal-body">
        <div class="receive-alarm-modal-body-left">
          <div class="receive-alarm-modal-body-left-item"
            :class="{'receive-alarm-modal-body-left-item-checked': index == currentIndex}"
            v-for="(item,index) in alarm_list" :key="index" @click="deviceAlarmChange(index)">
            <Tooltip placement="left" max-width="500">
              <div>设备号：{{ item.device_id }}</div>
              <div>报警类型：{{ item.type_text }}</div>
              <template slot="content">
                <div>设备号：{{ item.device_id }}</div>
                <div>报警类型：{{ item.type_text }}</div>
              </template>
            </Tooltip>
          </div>
        </div>
        <div class="receive-alarm-modal-body-right">
          <div v-if="data.latitude && data.longitude" id="receiveAlarmMap"></div>
          <div v-else class="no-longitude">无定位信息</div>
          <div class="user-info">
            <div class="mar-right-20">
              <div>机构名称：{{ data.m_name || '无' }}</div>
              <div>报警类型：{{ data.type_text }}</div>
              <div>报警时间：{{ data.create_date }}</div>
              <div v-if="data.addr">报警地址：{{ data.addr }}</div>
            </div>
            <div v-if="data.is_binding">
              <div>用户昵称：{{ data.u_name }}</div>
              <div>用户手机号：{{ data.u_phone }}</div>
              <div>设备昵称：{{ data.d_name }}</div>
              <div>设备手机号：{{ data.d_phone }}</div>
            </div>
          </div>
          <!-- <div v-else class="no-binding">没有绑定设备</div> -->
        </div>
      </div>

    </Modal>
  </div>
</template>

<script>
  import mqtt from "mqtt";
  import AMapLoader from '@amap/amap-jsapi-loader';
  import {
    shallowRef
  } from '@vue/reactivity'
  export default {
    name: 'ReceiveAlarm',
    data() {
      return {
        path: this.$store.state.store_type == 4 ? '/machine' : '/adm', // 区分在机构后台还是商家后台
        //地图实例创建者
        AMap: null,
        alarm_list: [], // sos报警弹窗展开时，收到新的报警则列表新增一个
        currentIndex: -1, // 默认选择的设备报警信息
        data: {},
        audioSrc: require('@/assets/mp3/baojing.mp3'),
        create_date: 0,
        timer: null,
        modal: {
          show: false
        },
        circle: null,
        // mqtt 获取报警数据
        client: {
          connected: false,
        },
        retryTimes: 0,
        connection: {
          url: this.MqttUrl,
          clean: true,
          reconnectPeriod: 500, // ms
          clientId: "vueXunLiaoReceiveAlarm" + Math.random().toString(16).substring(2, 8),
          username: "xunliao",
          password: "123456",
        },
        store_type: 1,
        SYSTEM_SAAS_OR_APP: {},
        SYSTEM_MECHANISM: {},
        userInfo: {}
      }
    },
    setup() {
      //地图实例
      const map = shallowRef(null);
      return {
        map
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        const _this = this;
        const store_type = parseInt(this.$store.state.store_type);
        const SYSTEM_SAAS_OR_APP = JSON.parse(localStorage.getItem('SYSTEM_SAAS_OR_APP'));
        const SYSTEM_MECHANISM = JSON.parse(localStorage.getItem('SYSTEM_MECHANISM'));
        var userInfo = null;
        if ((store_type === 4 && SYSTEM_MECHANISM) || (store_type === 1 && SYSTEM_SAAS_OR_APP)) {
          // 当前账号信息
          if (store_type === 4) {
            _this.userInfo = SYSTEM_MECHANISM.userInfo;
          } else {
            _this.userInfo = SYSTEM_SAAS_OR_APP.userInfo;
          }

          // 开启定时器
          this.timer = setInterval(() => {
            _this.store_type = parseInt(this.$store.state.store_type);
            _this.SYSTEM_SAAS_OR_APP = JSON.parse(localStorage.getItem('SYSTEM_SAAS_OR_APP'));
            _this.SYSTEM_MECHANISM = JSON.parse(localStorage.getItem('SYSTEM_MECHANISM'));
            // 判断是否在机构和商家
            if (_this.store_type === 4) {
              // 机构后台
              if (!_this.SYSTEM_MECHANISM) {
                _this.close();
              }
            } else if (_this.store_type === 1) {
              // 商家后台
              if (!_this.SYSTEM_SAAS_OR_APP) {
                _this.close();
              }
            } else {
              _this.close();
            }
            // // 当前账号信息
            // if (_this.store_type === 4) {
            //   _this.userInfo = _this.SYSTEM_MECHANISM.userInfo;
            // } else {
            //   _this.userInfo = _this.SYSTEM_SAAS_OR_APP.userInfo;
            // }
            // if (
            //   (_this.store_type !== 4 && _this.store_type !== 1) ||
            //   ((_this.store_type === 4 && !_this.SYSTEM_MECHANISM) || (_this.store_type === 1 && !_this.SYSTEM_SAAS_OR_APP))
            // ) {
            //   _this.close();
            // }
          }, 1000);


          this.requestApi(this.path + "/get_device_alarm_config").then((res) => {
            if (res.status === 1) {
              _this.deviceAlarmConfig = res.data;
              // 获取接收报警配置
              if (this.$store.state.store_type == 1) {
                this.createConnection(['xunliao/receive/alarm/' + _this.userInfo.store_id + '/#']);
              } else {
                this.requestApi(this.path + '/get_device_alarm_mqtt').then((res) => {
                  if (res.status == 1) {
                    this.createConnection(res.data);
                  }
                });
              }
            }
          });

        }
      },
      // 关闭 定时器
      close() {
        clearInterval(this.timer);
        // 赋值为null以免定时器无法正常开启
        this.timer = null;
        // 断开连接
        this.destroyConnection();
      },
      // 初始化地图
      MapInit() {
        var _this = this;
        if (_this.data.latitude && _this.data.longitude) {
          AMapLoader.load({
            key: 'd82cb44ac9310ae88e1cd4c1dfa612d9',
            version: "2.0",
            plugins: ['AMap.Scale', 'AMap.CircleEditor', 'AMap.AutoComplete'], // 插件列表，如比例尺'AMap.Scale'等
          }).then((AMap) => {
            _this.AMap = AMap
            _this.map = new AMap.Map("receiveAlarmMap", { //设置地图容器id
              viewMode: "2D", //是否为3D地图模式
              zoom: 5 //初始化地图级别
            });
            // 报警类型是 电子围栏报警
            if (_this.data.type == 23) {
              // 创建圆形实例
              _this.circle = new AMap.Circle({
                center: new AMap.LngLat(_this.data.enc_longitude, _this.data.enc_latitude), // 圆心位置
                radius: _this.data.enc_radius, // 圆半径
                fillColor: '#00B2D5', // 圆形填充颜色
                strokeColor: '#fff', // 描边颜色
                strokeWeight: 2, // 描边宽度
                draggable: false
              });
              _this.map.add(_this.circle);
            }
            // 设备上传的位置
            let content = "<div class='custom-content-marker'>" +
              "<img src='https://www.yiyangiot.com/assets/ic_marker_bg_white.632936f0.png' />" +
              "<img src='//xunliao-1-1257941115.cos.ap-nanjing.myqcloud.com/store_13/2022-08-08/1659924688423.png' class='green' />" +
              "<img class='avatar' src='//xunliao-1-1257941115.cos.ap-nanjing.myqcloud.com/store_13/2022-08-08/1659923948257.png' />" +
              "</div>";
            var marker = new AMap.Marker({
              position: new AMap.LngLat(_this.data.longitude, _this.data.latitude),
              offset: new AMap.Pixel(-23, -55),
              content: content,
              zoom: 13
            })
            _this.map.add([marker]);

            _this.map.setFitView()
          })
        }
      },
      // 关闭弹窗
      cancelAlarm() {
        if (this.map) {
          this.map.destroy();
        }
        this.modal.show = false;
        this.circle = null;
        this.map = null;
        this.$refs.audio1.pause()
        this.alarm_list = [];
        this.currentIndex = -1
      },
      // 改变设备报警信息
      deviceAlarmChange(index) {
        if (this.map) {
          this.map.destroy();
        }
        this.currentIndex = index;
        this.circle = null;
        this.map = null;
        this.data = this.alarm_list[index];
        this.MapInit();
      },
      initData() {
        this.client = {
          connected: false,
        };
        this.retryTimes = 0;
      },
      handleOnReConnect() {
        this.retryTimes += 1;
        if (this.retryTimes > 5) {
          try {
            this.client.end();
            this.initData();
            this.alertErr("Connection maxReconnectTimes limit, stop retry");
          } catch (error) {
            this.alertErr(error.toString());
          }
        }
      },
      // 创建mqtt 连接
      createConnection(topics) {
        // console.log(topics);
        try {
          const _this = this;
          // 连接配置
          const {
            url,
            ...options
          } = this.connection;
          // 创建连接
          this.client = mqtt.connect(url, options);
          if (this.client.on) {
            // 监听连接成功
            this.client.on("connect", () => {
              // console.log("接收报警数据 连接成功", topics);
              // 订阅主题
              for (let index = 0; index < topics.length; index++) {
                _this.client.subscribe(topics[index], {
                  qos: 0
                }, (error) => {
                  if (error) {
                    console.log(error);
                  }
                });
              }

            });
            // 连接失败
            this.client.on("error", (error) => {
              console.log("连接失败", error);
            });
            // 监听消息
            this.client.on("message", (topic, message) => {
              var uint8Msg = new Uint8Array(message);
              // 解码成字符串
              var decodedString = String.fromCharCode.apply(null, uint8Msg);
              // 转成json数据
              var data = JSON.parse(decodedString);

              if (
                (_this.deviceAlarmConfig['device_alarm_' + data.type] == 1) ||
                (_this.deviceAlarmConfig.sos_alarm == 1 && data.type == 2) ||
                (_this.deviceAlarmConfig.electronic_fence_alarm == 1 && data.type == 23)
              ) {
                // 如果后台有自己设置报警音频则用设置的
                if (data.alarmAudio) {
                  _this.audioSrc = data.alarmAudio;
                }
                // 报警提示音
                _this.$refs.audio1.muted = false;
                _this.$refs.audio1.currentTime = 0; // 从头开始
                _this.$refs.audio1.play().catch((result) => {}); // 播放提示音
                // if (data.type == 2 || data.type == 23 || data.type == 4) {
                // _this.$refs.audio1.loop = true;
                // 未打开弹窗时
                if (_this.alarm_list.length == 0) {
                  _this.data = data;
                  _this.modal.show = true;
                  _this.MapInit();
                }
                _this.alarm_list.unshift(data);
                _this.currentIndex = _this.currentIndex + 1;
                // } else {
                //   if (_this.alarm_list.length == 0) {
                //     _this.$refs.audio1.loop = false;
                //   }
                //   _this.$Notice.warning({
                //     title: data.type_text,
                //     desc: data.device_id + ' 正在发起' + data.type_text,
                //     duration: 5
                //   });
                // }
              }
            });
          }
        } catch (error) {
          console.log("mqtt.connect error", error);
        }
      },
      // 断开连接
      destroyConnection() {
        const _this = this;
        if (this.client.connected) {
          try {
            _this.client.end(false, () => {
              _this.initData();
              console.log('断开连接');
            });
          } catch (error) {
            console.log('断开失败', error.toString());
          }
        }
      },
    }
  }
</script>

<style scoped>
  .receive-alarm-modal-body {
    width: 100%;
    height: auto;
    display: flex;
  }

  .receive-alarm-modal-body-left {
    width: calc(20% - 12px);
    min-width: calc(20% - 12px);
    margin-right: 12px;
    /* border-top: 1px solid #dddddd; */
    overflow-y: auto;
    max-height: 540px;
  }

  .receive-alarm-modal-body-left-item {
    width: 100%;
    height: 60px;
    line-height: 30px;
    padding: 0 16px;
    border-bottom: 1px solid #eee;
    overflow: hidden;
    cursor: pointer;
  }

  .receive-alarm-modal-body-left-item:last-child {
    border-bottom: none;
  }

  .receive-alarm-modal-body-left-item div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }

  .receive-alarm-modal-body-left-item-checked {
    color: #2d8cf0;
  }

  .receive-alarm-modal-body-right {
    width: 80%;
    min-width: 80%;
  }

  .receive-alarm-modal-body-right .no-longitude {
    width: 100%;
    height: 420px;
    background: #f8f8f8;
    line-height: 420px;
    text-align: center;
    font-size: 36px;
    color: #999;
  }

  #receiveAlarmMap {
    padding: 0px;
    margin: 0px;
    width: 100%;
    height: 420px;
  }

  .user-info {
    margin-top: 12px;
    line-height: 36px;
    display: flex;
  }

  .no-binding {
    height: 100px;
    line-height: 100px;
    font-size: 20px;
    color: #666;
    text-align: center;
  }

  .mar-right-20 {
    margin-right: 20px;
  }

  /deep/ .custom-content-marker {
    position: relative;
  }

  /deep/ .custom-content-marker img {
    width: 45px;
    position: absolute;
    left: 0;
    top: 0;
  }

  /deep/ .custom-content-marker .avatar {
    width: 40px;
    height: 40px;
    left: 2.5px;
    top: 2.5px;
    border-radius: 50%;
  }

  /deep/ .custom-content-marker:hover .green {
    display: block;
  }

  /deep/ .custom-content-marker .green {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/adm/healthy/receive_alarm.vue